/**
 * Primitive color palette — single source of truth for all hex values.
 * Names follow Tailwind's naming convention for familiarity.
 */

// ── Opacity scale ────────────────────────────────────────────────────
export const OPACITY = {
    subtle: 0.08,
    muted: 0.12,
    soft: 0.2,
    medium: 0.5,
} as const;

/** Convert a hex color + alpha to an rgba() string. */
export function rgba(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${String(r)}, ${String(g)}, ${String(b)}, ${String(alpha)})`;
}

// ── Neutral ──────────────────────────────────────────────────────────
export const WHITE = '#ffffff';

// ── Slate ────────────────────────────────────────────────────────────
export const SLATE_50 = '#f8fafc';
export const SLATE_100 = '#f1f5f9';
export const SLATE_200 = '#e2e8f0';
export const SLATE_400 = '#94a3b8';
export const SLATE_600 = '#475569';
export const SLATE_800 = '#1e293b';
export const SLATE_900 = '#0f172a';
export const SLATE_950 = '#1a1f3a';

// ── Indigo ───────────────────────────────────────────────────────────
export const INDIGO_400 = '#818cf8';
export const INDIGO_500 = '#6366f1';
export const INDIGO_600 = '#4f46e5';
export const INDIGO_800 = '#3730a3';

// ── Violet ───────────────────────────────────────────────────────────
export const VIOLET_600 = '#7c3aed';
export const VIOLET_800 = '#5b21b6';

// ── Purple ───────────────────────────────────────────────────────────
export const PURPLE_400 = '#c084fc';
export const PURPLE_500 = '#a855f7';

// ── Red ──────────────────────────────────────────────────────────────
export const RED_400 = '#f87171';
export const RED_500 = '#ef4444';
export const RED_600 = '#dc2626';
export const RED_800 = '#b91c1c';

// ── Amber ────────────────────────────────────────────────────────────
export const AMBER_500 = '#f59e0b';
export const AMBER_600 = '#d97706';
